import { DefChartOpts } from '@features/social-analysis/models/IChart';
import { ChartType } from 'ng-apexcharts';

export const mainColors = {
    primary: '#8512BA',
    secondary: '#E849B2',
    third: '#EE7D15',
    fourth: '#95BF46',
    fifth: '#09AAFF',
    sixth: '#12B25C',
    seventh: '#A70606',
    eight: '#2F3C48',
};

const colorsArr = Object.values(mainColors);

export const mainComplementaryColors = {
    primary: '#F8EFFF',
    secondary: '#FDE6F8',
    third: '#FFF7F0',
    fourth: '#F1F9E3',
};

export const extraColors = {
    comparePrimary: '#DEC7EF',
    compareSecondary: '#FADBF0',
    forecast: '#EE7D15',
};

const fontSize = '11px';
const fontWeight = '400';

export const lineChartOptions: DefChartOpts = {
    chart: {
        height: 450,
        type: 'line' as ChartType,
    },
    colors: colorsArr,
    dataLabels: {
        enabled: false,
    },
    stroke: {
        curve: 'smooth' as const,
        width: 2,
    },
    fill: {
        colors: colorsArr,
        opacity: 1,
    },
    markers: {
        strokeColors: colorsArr,
        colors: ['#ffffff'],
        size: 3,
        strokeWidth: 2,
    },
    xaxis: {
        tooltip: {
            enabled: false,
        },
    },
    series: [],
    yaxis: [],
    tooltip: {
        onDatasetHover: {
            highlightDataSeries: true,
        },
        fixed: {
            enabled: true,
            position: 'topLeft',
            // offsetY: 30,
            offsetX: 20,
        },
    },
    legend: {
        show: false,
    },
};

export const yaxisOpts = [
    {
        decimalsInFloat: 2,
        axisBorder: {
            show: false,
            color: mainColors.primary,
        },
        labels: {
            style: {
                colors: mainColors.primary,
            },
        },
        title: {
            offsetX: -8,
            style: {
                fontSize: fontSize,
                fontWeight: fontWeight,
                color: mainColors.primary,
            },
        },
    },
    {
        decimalsInFloat: 2,
        opposite: true,
        axisBorder: {
            show: false,
            color: mainColors.secondary,
        },
        labels: {
            style: {
                colors: mainColors.secondary,
            },
        },
        title: {
            offsetX: 8,
            style: {
                fontSize: fontSize,
                fontWeight: fontWeight,
                color: mainColors.secondary,
            },
        },
    },
];
